module.exports = __webpack_public_path__ + "static/media/updateInormation.1eafa52b.svg";